import { createContext, useState } from 'react';
import InfoModal from 'ui-component/modals/InfoModal';
import ConfirmationModal from 'ui-component/modals/ConfirmationModal';
import PropTypes from 'prop-types';

export const ModalContext = createContext();

const ModalContextProvider = ({ children }) => {
    const [infoModal, setOpenInfoModal] = useState(false);
    const [confirmationModal, setOpenConfirmationModal] = useState(false);

    return (
        <ModalContext.Provider value={{ setOpenInfoModal, setOpenConfirmationModal }}>
            <InfoModal data={infoModal} onClose={() => setOpenInfoModal({ ...infoModal, isOpen: false })} />
            <ConfirmationModal data={confirmationModal} onClose={() => setOpenConfirmationModal({ ...confirmationModal, isOpen: false })} />
            {children}
        </ModalContext.Provider>
    );
};

ModalContextProvider.propTypes = {
    children: PropTypes.node
};

export default ModalContextProvider;
